import React from "react";
import Food from "../img/food.jpg";
import Food2 from "../img/food2.jpg";
import Food3 from "../img/food3.jpg";
import NachBokenheim from "../img/nachbockenheim.jpg";

// const spell = new Audio(AudioFile)

class AboutUs extends React.Component {
  constructor() {
    super();
    this.state = { category: "vor" };
    // console.log(MenuItems())
  }

  render() {
    return (
      <div>
        <div
          style={{
            backgroundImage: "url(" + NachBokenheim + ")",
            backgroundRepeat: "no-repeat",
            height: "auto",
            backgroundPosition: "center",
            backgroundSize: "cover",
            display: "flex",
            flexDirection: "column-reversed",
            textAlign: "center",
            wordWrap: "break-word",
          }}
        ></div>

        <div className="aboutus-article">
          <div className="aboutus-article__image">
            <img
              src={Food2}
              style={{
                width: "100%",
                display: "grid",
                marginBottom: "0",
                float: "left",
              }}
            />
          </div>
          <div className="aboutus-article__text">
            <h1>Exquisite Zutaten, authentischer Genuss</h1>
            <p>
              Unsere Küche lebt von erlesenen Zutaten höchster Qualität und
              handverlesenen frischen Produkten, die wir mit Leidenschaft und
              Sorgfalt auswählen. Jedes Gericht erzählt eine Geschichte von
              Tradition und Raffinesse. Auch unsere exklusive Weinselektion
              wurde mit Bedacht zusammengestellt, um Ihr kulinarisches Erlebnis
              perfekt abzurunden. Entdecken Sie die Vielfalt unserer
              Speisekarte!
            </p>
          </div>
        </div>
        <div
          className="aboutus-article"
          style={{ flexDirection: "row-reverse" }}
        >
          <div className="aboutus-article__image">
            <img
              src={Food}
              style={{
                width: "100%",
                display: "grid",
                marginBottom: "0",
              }}
            />
          </div>

          <div className="aboutus-article__text">
            <h1>Authentische Aromen Südostasiens</h1>
            <p>
              Mit jahrelanger Hingabe und Expertise in der südostasiatischen
              Küche kreiert unser Küchenteam für Sie Gerichte von
              außergewöhnlicher Qualität und Authentizität. Wir legen besonderen
              Wert auf natürliche Aromen – deshalb verzichten wir bewusst auf
              Glutamat und künstliche Geschmacksverstärker. Erleben Sie den
              unverfälschten Geschmack traditioneller Rezepte, neu interpretiert
              mit modernem Flair.
            </p>
          </div>
        </div>

        <div className="aboutus-article">
          <div className="aboutus-article__image">
            <img
              src={Food3}
              style={{
                width: "100%",
                display: "grid",
                marginBottom: "0",
              }}
            />
          </div>

          <div className="aboutus-article__text">
            <h1>Atmosphäre zum Wohlfühlen</h1>
            <p>
              Tauchen Sie ein in unsere südostasiatische Oase mitten in
              Bockenheim. Das stilvolle Ambiente mit authentischen
              Designelementen und warmer Atmosphäre lädt Sie ein, den Alltag
              hinter sich zu lassen. Bei Vietpho Cuisine verbinden sich
              kulinarischer Genuss und entspanntes Ambiente zu einem
              unvergesslichen Erlebnis für alle Sinne.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/aboutus.js